import { Table, TableBody, TableHead, TableCell, TableRow } from '@mui/material';
import { CLayer } from '@models/maps/Layer';
import { Icon, Tooltip, Link, IconButton } from '@ts/storybook';
import { useTranslation } from 'react-i18next';
import { WrapperEntitySelector } from '@components/Inputs';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { useNavigate } from 'react-router';
import { IForm } from '@ts/ui-models';

interface IViewLayerSelectorProps extends IForm {
  entitiesSelected?: CLayer[];
  onEntitySelected: (entity: CLayer) => void;
  onEntityRemoved: (entity: CLayer) => void;
  renderEntityColumns?: (entity: CLayer, indIdx: number) => React.ReactNode;
  renderEntityActions?: (entity: CLayer, indIdx: number) => React.ReactNode;
  fDisabled?: boolean;
  addEntityDisabled?: boolean;
}

const ViewLayerSelector = (props: IViewLayerSelectorProps) => {
  const { t } = useTranslation();
  const {
    entitiesSelected = [],
    onEntitySelected,
    onEntityRemoved,
    renderEntityActions,
    fDisabled,
    addEntityDisabled,
    mode,
  } = props;

  const isViewMode = mode === 'view';

  const navigate = useNavigate();

  const onClickLink = layer => {
    navigate(`/layer/${layer.getID()}/view`);
  };

  const renderEntities = () => {
    if (!entitiesSelected) return [];
    const rows = entitiesSelected.map((entity, indIdx) => {
      /* const cLayer: CLayer = new CLayer(entity);
      if (renderEntity) return renderEntity(cLayer, indIdx); */
      return (
        <TableRow key={indIdx}>
          <TableCell>
            <Link onClick={() => onClickLink(entity)} label={entity.getName()} />
          </TableCell>
          <TableCell>
            {renderEntityActions ? (
              renderEntityActions(entity, indIdx)
            ) : (
              <IconButton
                disabled={fDisabled}
                onClick={() => {
                  onEntityRemoved(entity);
                }}
              >
                <Icon icon="action-delete" />
              </IconButton>
            )}
          </TableCell>
        </TableRow>
      );
      //end map
    });
    return rows;
  };

  return (
    <>
      {!isViewMode && (
        <WrapperEntitySelector
          showAsButton={onClick => (
            <Tooltip title={'Add layer'}>
              <IconButton sx={{ zIndex: 5 }} onClick={onClick}>
                <Icon icon="addBox" size={25} />
              </IconButton>
            </Tooltip>
          )}
          searchComponent={generateSearchEntitySelector('layer')}
          onChangeEntity={value => onEntitySelected(value as CLayer)}
          multiple={false}
          disabled={fDisabled || addEntityDisabled}
        />
      )}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{`${t('Name')}`}</TableCell>
            <TableCell>{`${t('Actions')}`}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{renderEntities()}</TableBody>
      </Table>
    </>
  );
};

export default ViewLayerSelector;
